module.exports = __webpack_public_path__ + "static/media/11.b68d5cb4.jpg";